import {madnes_generate_frame_names} from "../framework/src/engine/madnes/madnes_anims";
import {server_config, behavior_config} from "../framework/src/engine/madnes/madnes_variables";
import {set_bonus_memory_index} from "./jokerboom_ctrl";

export var cylinder_pos_top = 148;
export var cylinder_pos = new Array();
cylinder_pos[0] = 195 + 20;
cylinder_pos[1] = 485 + 10;
cylinder_pos[2] = 785 - 10;
cylinder_pos[3] = 1080 - 20;


export function get_cylinder_x_shift(reelIndex)
{
    //return 0;

    switch(reelIndex)
    {
        case 0:
            return -30;
        case 1:
            return -15;
        case 2:
            return 15;
        case 3:
            return 30;
    }
}

var gameConfig = {
    autoStartDelay: 0
};

// Animace jednotlivych symbolu + pozice ve sprite
export var icons = {
    "symbol_Seven": {
        "anim": madnes_generate_frame_names("symbol_Seven_", 0, 32, "", 5)
    },
    "symbol_Melon": {
        "anim": madnes_generate_frame_names("symbol_Melon_", 0, 32, "", 5)
    },
    "symbol_Grape": {
        "anim": madnes_generate_frame_names("symbol_Grape_", 0, 32, "", 5)
    },
    "symbol_Star": {
        "anim": madnes_generate_frame_names("symbol_Star_", 0, 32, "", 5)
    },
    "symbol_Plum": {
        "anim": madnes_generate_frame_names("symbol_Plum_", 0, 32, "", 5)
    },
    "symbol_Orange": {
        "anim": madnes_generate_frame_names("symbol_Orange_", 0, 32, "", 5)
    },
    "symbol_Cherry": {
        "anim": madnes_generate_frame_names("symbol_Cherry_", 0, 32, "", 5)
    },
    "symbol_Lemon": {
        "anim": madnes_generate_frame_names("symbol_Lemon_", 0, 32, "", 5)
    },
    "symbol_Wild": {
        "anim": madnes_generate_frame_names("symbol_Wild_", 0, 32, "", 5)
    },
    "symbol_bigWild": {
        "anim": madnes_generate_frame_names("symbol_bigWild_", 0, 32, "", 5)
    },
    "symbol_Wild_locked": {
        "anim": madnes_generate_frame_names("symbol_Wild_locked_", 0, 34, "", 5)
    }
};

export var icons_tmp = new Array();
export var symbols = new Array();
export var last_symbol = new Array();

(function() {
    for(var i = 0; i < cylinder_pos.length; i++)
    {
        symbols[i] = -1;
        last_symbol[i] = -1;
    }
} ());


function init_game(dname, config, ver) {
    if(typeof ver === 'undefined') {
        ver = 1;
    }

    // madnes_game_title = "Joker Boom";

    // madnes_load_cstm_win_font = true;

    //madnes_set_renderer('auto');

    // madnes_config_load_symbols = false;

    // madnes_set_languages(['en', 'cs', 'sk']);
    // madnes_set_def_lang('en');

    //madnes_coins_shift = -80;

    //madnes_show_money_pos_x = wi / asi jo 2 - 50;
    //madnes_show_money_pos_y = he / 2 + 55;

    // madnes_show_money_anim_callback_timeout = 40;

    // madnes_load_init("joker_boom", config);

    //madnes_set_page_bg(dname, imgsPath + "web/background.png");

    // madnes_set_texture_version(ver);

    // madnes_set_ico_size(300, 194);
    // madnes_set_native_sceen_size(1280, 720);

// 	for(var i in to_load_audio)
// 	{
// 		madnes_add_audio(i, to_load_audio[i]);
// 	}
//
// 	for(var i in to_load)
// 	{
// 		madnes_add_to_load(i, to_load[i]);
// 	}
//
// 	for(var i in to_load_json)
// 	{
// 		if(infotexts_languages.indexOf(lang) === -1)
// 		{
// 			to_load_json[i] = to_load_json[i].replace("{l}", def_lang);
// 		}
//
// 		madnes_add_json(i, to_load_json[i]);
// 	}
//
// 	for(var i in to_load_json_atlas)
// 	{
// 		madnes_add_json_atlas_to_load(i, to_load_json_atlas[i][0], to_load_json_atlas[i][1]);
// 	}
//
// 	for(var i in to_load_fonts)
// 	{
// 		madnes_add_font_to_load(i, to_load_fonts[i]);
// 	}
//
// //	madnes_add_shader_to_load("hsv", "shaders/hsv.fs");
//
// 	//madnes_set_sprite('_sprite', 235, 160);
// 	//madnes_set_sprite('_blur', 235, 160);

    // madnes_set_sound_config_function(config_set_sound);
// 	madnes_set_printdesk_function(reels_print_desk);
// 	madnes_set_updatedesk_function(print_reels);
// //	madnes_set_load_complete_function(ctrl_init_bonus);
// 	madnes_set_rotate_function(rotate_run);
// //	madnes_set_on_rotate_click(rotate_onclick);
//
// 	madnes_set_sound_yes_function(sound_choose);
// 	madnes_set_sound_no_function(sound_choose);
//
// 	madnes_set_infomenu_init_function(infomenu_init);
// 	madnes_set_infomenu_open_function(infomenu_open);
// 	madnes_set_betmenu_choose_function(betmenu_choose);
// 	madnes_set_coinval_choose_function(betmenu_choose);
// 	madnes_set_infomenu_close_function(infomenu_close);
// 	madnes_set_infomenu_update_function(infomenu_update);
// 	madnes_set_infomenu_left_function(infomenu_left);
// 	madnes_set_infomenu_right_function(infomenu_right);
// 	madnes_set_betmenu_open_function(betmenu_open);
//
// 	madnes_set_coin_values_init(function(currency)
// 	{
// 		if(currency === "PLN")
// 		{
// 			coin_values = [0.1, 1];
// 		}
// 		else
// 		{
// 			madnes_coin_values_init(currency);
// 		}
// 	});


// //	madnes_set_on_key_down_function(ctrl_on_key_down);
//
// 	madnes_set_on_rotate_release(rotate_release);
// 	madnes_set_on_forcestop_press(forcestop_press);
//
// 	madnes_init(dname);
}

window['init_game'] = init_game;

function sound_choose() {
    set_bonus_memory_index(-1); //anim locked wild
};

export function set_game_config()
{
    console.log(server_config)
    server_config.behavior = behavior_config
    gameConfig.autoStartDelay = server_config["behavior"]["reel"]["autoStartDelay"];
}

export function config_set_cfg()
{
    if(typeof behavior_config.reel.spin.motionBlur == "undefined")
    {
        behavior_config.reel.spin.motionBlur = 1;
    }

    if(typeof behavior_config.reel.spin.timeToReachFullSpeed == "undefined")
    {
        behavior_config.reel.spin.timeToReachFullSpeed = 0.5;
        if(typeof behavior_config.reel.acceleration.spinAccelerationRatio != "undefined")
        {
            behavior_config.reel.spin.timeToReachFullSpeed = behavior_config.reel.acceleration.spinAccelerationRatio;
        }
    }

    if(typeof behavior_config.reel.spin.timeToReachNullSpeed == "undefined")
    {
        behavior_config.reel.spin.timeToReachNullSpeed = 0.5;
        if(typeof behavior_config.reel.acceleration.spinAccelerationRatio != "undefined")
        {
            behavior_config.reel.spin.timeToReachNullSpeed = behavior_config.reel.acceleration.spinAccelerationRatio;
        }
    }

    if(typeof behavior_config.reel.acceleration.moveTime != "undefined")
    {
        behavior_config.reel.spin.timeToReachFullSpeed = behavior_config.reel.acceleration.moveTime;
    }

    if(typeof behavior_config.reel.brake.moveTime != "undefined")
    {
        behavior_config.reel.spin.timeToReachNullSpeed = behavior_config.reel.brake.moveTime;
    }

    if(behavior_config.reel.spin.timeToReachFullSpeed == 0)
    {
        behavior_config.reel.spin.timeToReachFullSpeed = 0.01;
    }

    if(behavior_config.reel.spin.timeToReachNullSpeed == 0)
    {
        behavior_config.reel.spin.timeToReachNullSpeed = 0.01;
    }

    if(behavior_config.reel.spin.timeToReachFullSpeed > 0.5)
    {
        behavior_config.reel.spin.timeToReachFullSpeed = 0.5;
    }

    if(behavior_config.reel.spin.timeToReachNullSpeed > 0.5)
    {
        behavior_config.reel.spin.timeToReachNullSpeed = 0.5;
    }

    // madnes_set_win_factors(
    // 	behavior_config.reel.minBigWinFactor,
    // 	behavior_config.reel.minMegaWinFactor,
    // 	behavior_config.reel.minSuperMegaWinFactor
    // );

//	if(
//		typeof server_config.logic != "undefined" &&
//		typeof server_config.logic.bet_set != "undefined"
//	)
//	{
//		madnes_init_bets(server_config.logic.bet_set);
//	}
}